import * as React from "../../_snowpack/pkg/react.js";
import {
  getNatlAvgStat,
  getRecentAnnualDataAverages,
  getTextDegree
} from "../utils.js";
import BarGraphComparison from "./BarGraphComparison.js";
import NationalCountsGraph from "./NationalCountsGraph.js";
import RawDataTable from "./RawDataTable.js";
const DataPresentation = ({
  institution,
  degreeType,
  nationalCounts,
  nationalAverages
}) => {
  const textDegree = getTextDegree(degreeType);
  const recentAverages = getRecentAnnualDataAverages(institution?.degreesAwarded?.filter((annualData) => annualData.degreeType === degreeType)?.sort((a, b) => a.year - b.year).slice(0, 3) || []);
  const urmPhysicsDegreeCount = recentAverages ? recentAverages.domesticURMPhysicsDegreeCount : 0;
  return recentAverages ? /* @__PURE__ */ React.createElement("div", {
    className: "py-4 px-2"
  }, /* @__PURE__ */ React.createElement("h2", {
    className: "text-lg mb-4"
  }, textDegree), /* @__PURE__ */ React.createElement(BarGraphComparison, {
    id: "physicsToAll",
    title: `What percentage of all ${textDegree} degrees granted is physics degrees?`,
    instName: institution?.name,
    instPercentage: recentAverages?.physicsDegreeCount / recentAverages?.allDegreeCount * 100,
    natPercentage: getNatlAvgStat(nationalAverages, degreeType, 0),
    degreeText: textDegree
  }), /* @__PURE__ */ React.createElement(BarGraphComparison, {
    id: "physicsToStem",
    title: `What percentage of STEM ${textDegree} degrees granted is physics degrees?`,
    instName: institution?.name,
    instPercentage: recentAverages?.physicsDegreeCount / recentAverages?.stemDegreeCount * 100,
    natPercentage: getNatlAvgStat(nationalAverages, degreeType, 1),
    degreeText: textDegree
  }), /* @__PURE__ */ React.createElement(BarGraphComparison, {
    id: "womenToAllPhysics",
    title: `What percentage of physics ${textDegree} degrees is granted to women?`,
    instName: institution?.name,
    instPercentage: recentAverages?.womenPhysicsDegreeCount / recentAverages?.physicsDegreeCount * 100,
    natPercentage: getNatlAvgStat(nationalAverages, degreeType, 2),
    degreeText: textDegree
  }), /* @__PURE__ */ React.createElement(BarGraphComparison, {
    id: "UrmToAllPhysics",
    title: `What percentage of physics ${textDegree} degrees awarded to U.S. citizens and permanent residents is granted to underrepresented minorities (URM)?†`,
    instName: institution?.name,
    instPercentage: urmPhysicsDegreeCount / recentAverages?.domesticStudentPhysicsDegreeCount * 100,
    stateData: institution?.stateData,
    natPercentage: getNatlAvgStat(nationalAverages, degreeType, 3),
    degreeText: textDegree
  }), institution ? /* @__PURE__ */ React.createElement(RawDataTable, {
    institution
  }) : /* @__PURE__ */ React.createElement(React.Fragment, null), institution && nationalCounts ? /* @__PURE__ */ React.createElement(NationalCountsGraph, {
    nationalCounts,
    degreeType,
    instName: institution.name,
    ficeCode: institution.ficeCode
  }) : /* @__PURE__ */ React.createElement(React.Fragment, null)) : /* @__PURE__ */ React.createElement("h2", {
    className: "text-lg py-4 px-2"
  }, "No data found");
};
export default DataPresentation;
